(function () {
  angular.module('app.widgets.common.go-url').component('appGoUrl', {
    bindings: {
      name: '@',
    },
    templateUrl: 'app/widgets/common/go-url/go-url.component.html',
    transclude: true,
  });
})();
